import { createFileRoute, notFound } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { useSuspenseQuery } from '@tanstack/react-query'
import type { Id } from 'convex/_generated/dataModel'
import UpdateTaskForm from '@/features/tasks/components/UpdateTaskForm'

export const Route = createFileRoute('/_authed/tasks/$taskId')({
  loader: async ({ params, context }) => {
    const { taskId } = params
    
    // Validate params
    if (!taskId || typeof taskId !== 'string') {
      throw notFound()
    }
    
    // Preload critical data - ensures data is available before render
    const task = await context.queryClient.ensureQueryData(
      convexQuery(api.tasks.getTask, { taskId: taskId as Id<'tasks'> })
    )
    
    // Throw notFound if resource doesn't exist
    if (!task) {
      throw notFound()
    }
    
    return { taskId: taskId as Id<'tasks'> }
  },
  component: TaskDetailRoute,
})

function TaskDetailRoute() {
  const { taskId } = Route.useParams()
  
  // Use suspense query to read from cache (data already loaded in loader)
  const { data: task } = useSuspenseQuery(
    convexQuery(api.tasks.getTask, { taskId: taskId as Id<'tasks'> })
  )
  
  // Task is guaranteed to exist due to loader validation
  if (!task) {
    throw new Error('Task should exist at this point')
  }
  
  return <UpdateTaskForm task={task} />
}
